import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ArrowUpRight, Clock } from "lucide-react";
import ConfidenceBadge from "./ConfidenceBadge";
import NicheComTag from "../NicheComTag";

export default function OpportunityFeed({ opportunities = [], count, gain }) {
  const navigate = useNavigate();
  if (!opportunities.length) return null;
  return (
    <div data-testid="growth-opportunities">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold tracking-tight text-ink">Growth opportunities</h2>
        <span className="text-sm font-semibold" style={{ color: "#5F8213" }}>{count ?? opportunities.length} opportunities worth +{gain ?? opportunities.reduce((s, o) => s + (o.uplift || 0), 0)} points</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {opportunities.map((o, i) => (
          <motion.div key={o.id} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.04 }}
            className="card card-hover p-5" data-testid={`opportunity-${o.id}`}>
            <div className="flex items-start gap-3">
              <span className="grid place-items-center min-w-[38px] h-8 rounded-md text-sm font-extrabold px-2" style={{ background: "rgba(147,192,32,.14)", color: "#5F8213" }}>+{o.uplift}</span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-semibold text-ink leading-snug">{o.title}</h3>
                  {o.asset_source === "nichecom" && <NicheComTag />}
                </div>
                <p className="text-sm text-ink-2 mt-1.5 leading-relaxed">{o.body || o.evidence}</p>
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  <ConfidenceBadge level={o.confidence} />
                  {o.freshness && <span className="inline-flex items-center gap-1 text-[11px] text-ink-3"><Clock size={11} strokeWidth={2} />{o.freshness}</span>}
                </div>
                <div className="flex items-center justify-between mt-3">
                  <span className="inline-flex items-center gap-1 text-xs font-bold" style={{ color: "#678A16" }}><ArrowUpRight size={13} strokeWidth={2} /> Potential gain +{o.uplift}</span>
                  <button className="text-sm font-semibold inline-flex items-center gap-1 hover:gap-1.5 transition-all text-ink" data-testid={`opportunity-cta-${o.id}`} onClick={() => navigate(`/app${o.action?.route || o.route}`)}>
                    {o.action?.label || o.cta} <ArrowRight size={14} strokeWidth={2} />
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
